import { Link } from 'react-router-dom';
import { categories } from '@/mocks/shows';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50/80">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-fill text-background-50 text-xl"></i>
              </span>
              <span className="font-heading text-lg text-background-50 whitespace-nowrap">
                屁屁影院
              </span>
            </Link>
            <p className="text-sm leading-relaxed text-background-50/60">
              电视剧全集免费在线观看不缓冲，最新热播同步剧集免费追，高清流畅剧集完整。
            </p>
          </div>

          {/* Categories */}
          <div>
            <h4 className="font-heading text-sm font-medium text-background-50 mb-4">
              <a href="/" className="hover:text-primary-400 transition-colors">内容分类</a>
            </h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-sm font-medium text-background-50 mb-4">
              <a href="/about" className="hover:text-primary-400 transition-colors">关于我们</a>
            </h4>
            <ul className="space-y-2">
              <li>
                <a href="/about#intro" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">
                  品牌介绍
                </a>
              </li>
              <li>
                <a href="/about#contact" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">
                  联系我们
                </a>
              </li>
              <li>
                <a href="/about#stats" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">
                  平台数据
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-sm font-medium text-background-50 mb-4">
              联系方式
            </h4>
            <ul className="space-y-2 text-sm text-background-50/60">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-400 w-4 h-4 flex items-center justify-center"></i>
                <span>contact@pipicinema.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-wechat-line text-primary-400 w-4 h-4 flex items-center justify-center"></i>
                <span>屁屁影院官方</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-weibo-line text-primary-400 w-4 h-4 flex items-center justify-center"></i>
                <span>@屁屁影院</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-background-50/10 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/40">
            &copy; {new Date().getFullYear()} 屁屁影院 版权所有
          </p>
          <p className="text-xs text-background-50/40">
            本站所有资源均来自互联网，仅供学习交流使用
          </p>
        </div>
      </div>
    </footer>
  );
}